/* src/app/modal/modal.component.scss */
.open modal {
  display: block;
}
modal {
  display: none;
  z-index: 999;
}
modal,
body.open:before {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
body.open:before {
  content: "";
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
}
.window {
  padding: 20px;
  margin: 100px auto;
  z-index: 1000;
  width: 500px;
  height: 400px;
  background-color: #fff !important;
}
/*# sourceMappingURL=modal.component.css.map */
